module.exports = __webpack_public_path__ + "static/media/TC01@s.c95aeb2d.jpg";